import React, { useContext, useState, useEffect } from "react";
import Header from "../../header/index";
import { Link } from "react-router-dom";
import { AppContext } from "../../../services/AuthContext";
import { updateUserDetails, updateUserPhoto, deleteUserPhoto } from "../../../services/userService";
import SettingsPageHeader from "./settingsPageHeader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Footer2 } from "../../footer2";
import defaultAvatar from '../../../assets/img/profiles/avatar-01.jpg';
import { invalidateProfilePhoto, loadProfilePhoto } from "../../../utils/photoCache";
import { getUserDetails } from "../../../services/userService";
import { Helmet } from "react-helmet-async";
import InputMask from 'react-input-mask';


const InstructorSettings = () => {
  const { auth, setAuth } = useContext(AppContext);
  const nvl = (v) => (v === null || v === undefined ? "" : v);
  const sanitize = (obj) =>
    Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, nvl(v)]));

  const [formData, setFormData] = useState({
    title: nvl(auth.title),
    name: nvl(auth.name),
    surname: nvl(auth.surname),
    email: nvl(auth.email),
    telephone: nvl(auth.telephone),
    address: nvl(auth.address),
    tc: nvl(auth.tc)
  });

  const [selectedImage, setSelectedImage] = useState(null); // input önizleme
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [photoLoading, setPhotoLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({}); const onlyDigitsLen = (v = "") => String(v).replace(/\D/g, "").length;
  const PHONE_DIGIT_TARGET = 12;
  // Sadece rakamları döndüren yardımcı fonksiyon
  const getDigitsOnly = (v = "") => String(v).replace(/\D/g, "");

  // Telefonun hedef rakam sayısına (12) ulaşıp ulaşmadığını kontrol eder
  const isValidPhone = (v = "") => getDigitsOnly(v).length === 12;
  const normalizeEmail = (email = "") => String(email).trim().toLowerCase();
  const [showDeleteModal, setShowDeleteModal] = useState(false);


  // 🔗 sunucudan dönen gerçek foto (blob → objectURL)
  const [photoUrl, setPhotoUrl] = useState(null);

  // --- YENİ SABİTLER ---
  const MAX_FILE_SIZE_MB = 6; // Maksimum dosya boyutu 6 MB olarak belirlendi
  const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  // --------------------

  // Sadece İngilizce harf, rakam, nokta, alt çizgi, tire, @ ve nokta
  const emailRe = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  const handleRemovePhoto = async () => {
    try {
      setIsUploading(true);
      const res = await deleteUserPhoto(auth.token);

      // auth ve UI temizle
      const next = { ...auth, profileimage: null };
      setAuth(next);
      sessionStorage.setItem("auth", JSON.stringify(next));
      setPhotoUrl(null);
      setSelectedFile(null);
      setSelectedImage(null);
      toast.success(res?.message || "Profil fotoğrafı kaldırıldı.");

    } catch (err) {
      console.error("Fotoğraf silme hatası:", err);
      toast.error("Fotoğraf kaldırılırken bir hata oluştu.");
    } finally {
      setIsUploading(false);
      setShowDeleteModal(false);
    }
  };


  const countDigits = (s = "") => (s.match(/\d/g) || []).length;

  // tel inputu: yalnızca başta +, kalanı rakam ve boşluk
  const normalizeTelephone = (v = "") => {
    // sadece +, rakam, boşluk bırak
    let s = String(v || "").replace(/[^\d +]/g, "");
    // '+' sadece başta olabilir, diğerlerini at
    s = s.startsWith("+") ? "+" + s.slice(1).replace(/\+/g, "") : s.replace(/\+/g, "");
    // birden çok boşluğu tek boşluğa indir, baştaki boşluğu kırp, trim
    s = s.replace(/\s+/g, " ").trim();
    return s;
  };

  const validateField = (name, value) => {
    let msg = "";
    switch (name) {
      case "name":
        if (!String(value || "").trim()) msg = "Ad zorunludur.";
        break;
      case "surname":
        if (!String(value || "").trim()) msg = "Soyad zorunludur.";
        break;
      case "email":
        if (!String(value || "").trim()) msg = "E-posta zorunludur.";
        else if (/[çğıöşüÇĞİÖŞÜ]/.test(value))
          msg = "E-posta adresinde Türkçe karakter bulunamaz.";
        else if (!emailRe.test(String(value).trim()))
          msg = "Geçerli bir e-posta girin.";
        break;
      case "telephone": {
        const digits = getDigitsOnly(value); // Maske karakterlerini (+, (, )) temizle

        if (digits.length === 0) {
          msg = "Telefon zorunludur.";
        } else if (digits.length < 12) {
          msg = "Telefon numarasını eksiksiz giriniz.";
        }
        // Eğer tam 12 rakamsa msg boş kalır (hata yok)
        break;
      }
      default:
        break;
    }
    return msg;
  };

  const validateAll = (data) => {
    const fields = ["name", "surname", "email", "telephone"];
    const next = {};
    fields.forEach((k) => {
      const m = validateField(k, data[k]);
      if (m) next[k] = m;
    });
    setErrors(next);
    return next;
  };

  // --- Yeni: sayfa açıldığında API'den çek ve hem auth'i hem formu doldur
  useEffect(() => {
    const fetchAndSet = async () => {
      if (!auth?.token) return;
      try {
        const res = await getUserDetails(auth.token);
        // servis dökümanına göre response: { status, message, data: { ... } }
        const payload = res?.data?.data ?? null;
        if (!payload) return;

        const updated = {
          ...auth,
          // doğrudan payload alanlarını alıyoruz
          title: payload.title ?? auth.title,
          name: payload.name ?? auth.name,
          surname: payload.surname ?? auth.surname,
          email: payload.email ?? auth.email,
          telephone: payload.telephone ?? auth.telephone,
          address: payload.address ?? auth.address,
          tc: payload.tc ?? auth.tc,
          profileimage: payload.profileimage ?? auth.profileimage,
          id: payload.id ?? auth.id,
        };

        // Global auth'i güncelle
        setAuth(updated);
        sessionStorage.setItem("auth", JSON.stringify(updated));

        // formu API verisiyle doldur
        setFormData({
          title: nvl(updated.title),
          name: nvl(updated.name),
          surname: nvl(updated.surname),
          email: nvl(updated.email),
          telephone: normalizeTelephone(updated.telephone),
          address: nvl(updated.address),
          tc: nvl(updated.tc),
        });
      } catch (err) {
        console.error("getUserDetails error:", err);
        // hata durumunda sessizce bırakabiliriz; istersen toast göster
      }
    };
    fetchAndSet();
    // sadece token değişirse yeniden çağır
  }, [auth?.token, setAuth]);

  // Fotoğraf URL yükleme (auth.profileimage/id değiştiğinde çalışır)
  useEffect(() => {
    let revoke;
    if (!auth?.id || !auth?.profileimage) { setPhotoUrl(null); return; }
    setPhotoLoading(true);
    loadProfilePhoto({ id: auth.id, fileName: auth.profileimage, token: auth.token })
      .then(({ url, revoke: rv }) => { setPhotoUrl(url); revoke = rv; })
      .catch(() => setPhotoUrl(null))
      .finally(() => setPhotoLoading(false));
    return () => { if (revoke) revoke(); };
  }, [auth?.id, auth?.profileimage, auth?.token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const v = name === "telephone" ? normalizeTelephone(value) : value;
    setFormData((s) => ({ ...s, [name]: v }));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((t) => ({ ...t, [name]: true }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, formData[name]) }));
  };

  // --- GÜNCELLENMİŞ: Dosya boyutu ve türü kontrolü eklendi ---
  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // 1. Dosya Türü Kontrolü
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.error(`Yalnızca JPEG, PNG, GIF veya WEBP formatında görsel yükleyebilirsiniz. Dosya türü: ${file.type}`);
      e.target.value = null; // Input'u sıfırla
      setSelectedFile(null);
      setSelectedImage(null);
      return;
    }

    // 2. Dosya Boyutu Kontrolü (20 MB)
    const maxSizeBytes = MAX_FILE_SIZE_MB * 1024 * 1024;
    if (file.size > maxSizeBytes) {
      toast.error(`Seçilen dosya ${MAX_FILE_SIZE_MB} MB'tan büyük olamaz.`);
      e.target.value = null; // Input'u sıfırla
      setSelectedFile(null);
      setSelectedImage(null);
      return;
    }

    setSelectedFile(file);
    setSelectedImage(URL.createObjectURL(file)); // sadece önizleme
  };
  // -----------------------------------------------------------

  // preview URL’i temizle
  useEffect(() => {
    return () => { if (selectedImage) URL.revokeObjectURL(selectedImage); };
  }, [selectedImage]);

  // upload
  const handlePhotoUpload = async () => {
    if (!selectedFile) { toast.info("Lütfen önce bir fotoğraf seçin."); return; }

    // NOT: Sıkıştırma kütüphanesi kullanılmadığı için burada sıkıştırma yapılmaz.
    // Doğrudan orijinal dosya yüklenir (20 MB'a kadar).

    try {
      setIsUploading(true);
      // selectedFile direkt olarak servise gönderiliyor
      const res = await updateUserPhoto(selectedFile, auth.token);
      const newFileName = res?.data?.profileimage || res?.data?.fileName || res?.data || null;

      if (newFileName) {
        await invalidateProfilePhoto({ id: auth.id, oldFileName: auth.profileimage });
        const next = { ...auth, profileimage: newFileName };
        setAuth(next);
        sessionStorage.setItem('auth', JSON.stringify(next));
        // preview’i sıfırla → useEffect sunucudan yeni blob’u çekecek
        if (selectedImage) URL.revokeObjectURL(selectedImage);
        setSelectedImage(null);
        setSelectedFile(null);
        setPhotoLoading(true);
        // taze blob’u çek → UI anında güncellensin
        try {
          const { url } = await loadProfilePhoto({ id: next.id, fileName: next.profileimage, token: next.token });
          setPhotoUrl(url);
        } catch { console.log("Yeni foto cache'den yüklenemedi."); }
      }

      toast.success(res?.message || "Profil fotoğrafı güncellendi.");
    } catch (err) {
      console.error(err);
      toast.error("Fotoğraf güncellenemedi. Lütfen tekrar deneyin.");
    } finally {
      setIsUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validateAll(formData);
    if (Object.keys(errs).length > 0) {
      // hataları birleştir ve kullanıcıya göster
      const msg = Object.values(errs).join(" • ");
      toast.error(msg);
      return;
    }
    try {
      const safeData = sanitize(formData);
      const response = await updateUserDetails(safeData, auth.token);
      // updateUserDetails'in döndürdüğü veriye bağlı olarak istersen response.data ile güncelle
      const next = { ...auth, ...safeData };
      setAuth(next);
      sessionStorage.setItem('auth', JSON.stringify(next));
      toast.success(response.message || "Profil güncellendi.");
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Profili güncellerken bir hata oluştu.");
    }
  };

  return (
    <div className="main-wrapper bg-body-tertiary min-vh-100">
      <Helmet>
        <title>İdealonline - Profil Ayarları</title>
      </Helmet>
      <Header activeMenu={"Settings"} />
      <div className="container py-5 mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 mx-auto">
            <div className="bg-white rounded-4 shadow-sm p-4 mt-5">
              <div className="text-center">
                <h3 className="fw-semibold border-bottom pb-2 text-newdarkfume">Profil</h3>
                <div className="d-flex flex-column align-items-center mt-3 mb-4">
                  <div className="position-relative" style={{ width: 96, height: 96 }}>
                    <img
                      src={selectedImage || photoUrl || defaultAvatar}
                      alt="Profil Fotoğrafı"
                      className="rounded-circle border"
                      style={{ width: 96, height: 96, objectFit: "cover" }}
                      onLoad={() => setPhotoLoading(false)}
                      onError={(e) => {
                        e.currentTarget.src = defaultAvatar;
                        setPhotoLoading(false);
                      }}
                    />

                    {(photoLoading || isUploading) && (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          position: "absolute",
                          inset: 0,
                          background: "rgba(255,255,255,.6)",
                          borderRadius: "50%",
                        }}
                      >
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-label="Yükleniyor"
                        />
                      </div>
                    )}

                    {photoUrl && !isUploading && (
                      <button
                        type="button"
                        onClick={() => setShowDeleteModal(true)}
                        aria-label="Fotoğrafı kaldır"
                        style={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          width: 24,
                          height: 24,
                          border: "none",
                          borderRadius: "50%",
                          fontWeight: "bold",
                          color: "red",
                          fontSize: 16,
                          lineHeight: "1",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#fff",
                        }}
                      >
                        ×
                      </button>
                    )}
                  </div>
                  <label
                    htmlFor="profile-photo-upload"
                    className="btn-primary btn px-3 py-2 mt-3 text-white text-xs fw-semibold"
                    style={{ cursor: 'pointer' }}
                  >
                    Fotoğraf Seç
                  </label>
                  <input
                    id="profile-photo-upload"
                    type="file"
                    // NOT: accept="image/*" tarayıcı düzeyinde kontrol sağlar, ancak JS kontrolü daha kesindir.
                    accept="image/jpeg,image/png,image/gif,image/webp"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                  />

                  {selectedFile && (
                    <button
                      type="button"
                      onClick={handlePhotoUpload}
                      className="btn-info btn-sm rounded-4 px-3 py-2 mt-2 text-white text-xs fw-semibold"
                      disabled={isUploading}
                    >
                      {isUploading ? "Yüklüyor..." : "Kaydet"}
                    </button>
                  )}
                </div>
              </div>

              <SettingsPageHeader />

              <form onSubmit={handleSubmit}>
                <div className="checkout-form settings-wrap mt-1">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-block">
                        <label className="text-sm text-darkfume">Ünvan</label>
                        <input
                          type="text"
                          className="form-control text-fume"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="input-block">
                        <label className="text-sm text-darkfume">Adı</label>
                        <input
                          type="text"
                          className={`form-control text-fume ${touched.name && errors.name ? "is-invalid" : ""}`}
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          aria-invalid={!!(touched.name && errors.name)}
                        />
                        {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="input-block">
                        <label className="text-sm text-darkfume">Soyadı</label>
                        <input
                          type="text"
                          className={`form-control text-fume ${touched.surname && errors.surname ? "is-invalid" : ""}`}
                          name="surname"
                          value={formData.surname}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          aria-invalid={!!(touched.surname && errors.surname)}
                        />
                        {touched.surname && errors.surname && <div className="invalid-feedback">{errors.surname}</div>}
                      </div>
                    </div>

                    {/* E-posta Alanı */}
                    <div className="col-md-6">
                      <div className="input-block">
                        <label className="text-sm text-darkfume">E-posta Adresi</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              email: e.target.value.toLowerCase().trim(),
                            }))
                          }
                          onBlur={handleBlur}
                          className={`form-control text-fume ${touched.email && errors.email ? "is-invalid" : ""
                            }`}
                          placeholder="ornek@domain.com"
                        />
                        {touched.email && errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>
                    </div>

                    {/* Telefon Alanı */}
                    <div className="col-md-6">
                      <div className="input-block">
                        <label className="text-sm text-darkfume">Telefon Numarası</label>
                        <InputMask
                          mask="+99(999)9999999"
                          value={formData.telephone}
                          onFocus={() => {
                            if (!formData.telephone || getDigitsOnly(formData.telephone).length === 0) {
                              setFormData({ ...formData, telephone: '+90' });
                            }
                          }}
                          onChange={(e) =>
                            setFormData((prev) => ({ ...prev, telephone: e.target.value }))
                          }
                          onBlur={handleBlur}
                        >
                          {(inputProps) => (
                            <input
                              {...inputProps}
                              type="tel"
                              name="telephone"
                              // isValidPhone yerine doğrudan merkezi errors state'ine bakıyoruz
                              className={`form-control text-fume ${touched.telephone && errors.telephone ? "is-invalid" : ""
                                }`}
                              placeholder="+90(555)0000000"
                              inputMode="tel"
                            />
                          )}
                        </InputMask>
                        {touched.telephone && errors.telephone && (
                          <div className="invalid-feedback">{errors.telephone}</div>
                        )}
                      </div>
                    </div>


                    <div className="col-md-6">
                      <div className="input-block">
                        <label className="text-darkfume text-sm ">Adres</label>
                        <input type="text" className="form-control text-fume" name="address" value={formData.address} onChange={handleChange} />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <button className="btn btn-primary text-sm fw-semibold px-3 py-2 mt-1 " type="submit" >
                        Profili Düzenle
                      </button>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
      <Footer2 />
      {/* Fotoğraf Silme Onay Modali */}
      {showDeleteModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.4)" }}
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content rounded-4 border-0 shadow">
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title fw-semibold text-newdarkfume">Fotoğrafı Kaldır</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDeleteModal(false)}
                  aria-label="Kapat"
                ></button>
              </div>
              <div className="modal-body text-center text-newdarkfume">
                <p>Profil fotoğrafınızı kaldırmak istediğinize emin misiniz?</p>
              </div>
              <div className="modal-footer border-0 d-flex justify-content-center">
                <button
                  type="button"
                  className="btn btn-newdarkfume px-3"
                  onClick={() => setShowDeleteModal(false)}
                >
                  Vazgeç
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-3"
                  onClick={handleRemovePhoto}
                  disabled={isUploading}
                >
                  {isUploading ? "Kaldırılıyor..." : "Evet, Kaldır"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default InstructorSettings;